module.exports = "/packs/media/images/car3-97524be0f032c2655d02b9db583fe0ca.jpg";